import { Moment } from 'moment';

import { CompanyDetailModel } from '@falcon/app/shared/models/company.model';
import { EmployeeModel } from '@falcon/app/shared/models/employee.model';
import { LabourAssignmentModel } from '@falcon/app/shared/models/labour-assignments.model';
import { ScheduleItem } from '@falcon/app/shared/models/contract.model';

export class CreateContractState {
  company: CompanyDetailModel | null = null;
  employee: EmployeeModel | null = null;
  dateFrom: Moment | null = null;
  dateTo: Moment | null = null;
  datePicker = {
    selectedTabIndex: 0,
  };
  pauseItems: ScheduleItem[] = [];
  scheduleItems: ScheduleItem[] = [];
  labourAssignment: LabourAssignmentModel | null = null;
}
